import { useState, useEffect } from "react";
import { API_BASE_URL } from "../config/api";

const cache = { data: null, ts: 0 };
const TTL = 5 * 60 * 1000;

export function useSettings() {
  const [settings, setSettings] = useState(cache.data);
  const [loading, setLoading] = useState(!cache.data);

  useEffect(() => {
    if (cache.data && Date.now() - cache.ts < TTL) {
      setSettings(cache.data);
      setLoading(false);
      return;
    }
    fetch(`${API_BASE_URL}/api/settings/`)
      .then((r) => r.json())
      .then((json) => {
        cache.data = json.settings;
        cache.ts = Date.now();
        setSettings(json.settings);
      })
      .finally(() => setLoading(false));
  }, []);

  const invalidate = () => { cache.data = null; cache.ts = 0; };

  return { settings, loading, invalidate };
}
